import type { UserFriendlyError } from "./types";
import { HTTP_STATUS_MESSAGES } from "./constants/httpStatusMessages";
import { authErrorPatterns } from "./constants/authErrorPatterns";
import { validationErrorPatterns } from "./constants/validationErrorPatterns";
import { customerErrorPatterns } from "./constants/customerErrorPatterns";
import { databaseErrorPatterns } from "./constants/databaseErrorPatterns";
import { notFoundErrorPatterns } from "./constants/notFoundErrorPatterns";
import { subscriptionErrorPatterns } from "./constants/otherErrorPatterns";
import { fileUploadErrorPatterns } from "./constants/otherErrorPatterns";
import { networkErrorPatterns } from "./constants/otherErrorPatterns";
import { databaseSpecificErrorPatterns } from "./constants/otherErrorPatterns";
import { anchoringErrorPatterns } from "./constants/otherErrorPatterns";
import { thirdPartyErrorPatterns } from "./constants/otherErrorPatterns";
import { memberRemovalErrorPatterns } from "./constants/otherErrorPatterns";
import { externalServiceErrorPatterns } from "./constants/externalServiceErrorPatterns";

export { HTTP_STATUS_MESSAGES };

/**
 * Mapping des messages d'erreur techniques vers messages vulgarisés
 * Le message peut être soit un objet UserFriendlyError, soit une fonction qui retourne un UserFriendlyError
 */
export const ERROR_PATTERNS: Array<{
	pattern: RegExp;
	message: UserFriendlyError | ((match: RegExpMatchArray) => UserFriendlyError);
}> = [
	...authErrorPatterns,
	...validationErrorPatterns,
	...customerErrorPatterns,
	...databaseErrorPatterns,
	...notFoundErrorPatterns,
	...subscriptionErrorPatterns,
	...fileUploadErrorPatterns,
	...networkErrorPatterns,
	...externalServiceErrorPatterns,
	...databaseSpecificErrorPatterns,
	...anchoringErrorPatterns,
	...thirdPartyErrorPatterns,
	...memberRemovalErrorPatterns,
];
